var _excluded = ["arrowButtons", "children", "hideScrollbar", "onLeftScroll", "onRightScroll"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Grid, Icon, Ref } from 'semantic-ui-react';

/**
 * Horizontal scroll handler with buttons.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HorizontalScroller = function HorizontalScroller(props) {
  var arrowButtons = props.arrowButtons,
    children = props.children,
    hideScrollbar = props.hideScrollbar,
    onLeftScroll = props.onLeftScroll,
    onRightScroll = props.onRightScroll,
    rest = _objectWithoutPropertiesLoose(props, _excluded);

  /* eslint-disable */
  var _React$useState = React.useState(null),
    containerRef = _React$useState[0],
    setContainerRef = _React$useState[1];
  var _React$useState2 = React.useState(null),
    containerWidth = _React$useState2[0],
    setContainerWidth = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    containerHeight = _React$useState3[0],
    setContainerHeight = _React$useState3[1];
  var _React$useState4 = React.useState(0),
    scrollPosition = _React$useState4[0],
    setScrollPosition = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    childrenWidth = _React$useState5[0],
    setChildrenWidth = _React$useState5[1];
  var _React$useState6 = React.useState(_.uniqueId()),
    uniqueId = _React$useState6[0];
  /* eslint-enable */

  React.useEffect(function () {
    if (containerRef) {
      if (containerRef.scrollLeft !== scrollPosition) {
        containerRef.scrollTo({
          left: _.ceil(scrollPosition),
          behavior: 'smooth'
        });
      }
    }
  }, [containerRef, scrollPosition]);
  var handleRef = function handleRef(node) {
    var resizeObserver = new ResizeObserver(function (entries) {
      _.map(entries, function (entry) {
        if (entry.contentRect) {
          var _entry$contentRect, _entry$contentRect2;
          setContainerWidth((_entry$contentRect = entry.contentRect) == null ? void 0 : _entry$contentRect.width);
          setContainerHeight((_entry$contentRect2 = entry.contentRect) == null ? void 0 : _entry$contentRect2.height);
          setContainerRef(node);
        }
      });
    });
    if (!_.isNil(node)) {
      resizeObserver.observe(node);
    }
  };
  var handleChildrenRef = function handleChildrenRef(node) {
    var resizeObserver = new ResizeObserver(function (entries) {
      _.map(entries, function (entry) {
        if (entry.contentRect) {
          var _entry$contentRect3;
          setChildrenWidth((_entry$contentRect3 = entry.contentRect) == null ? void 0 : _entry$contentRect3.width);
        }
      });
    });
    if (!_.isNil(node)) {
      resizeObserver.observe(node);
    }
  };
  var handleManuallyScroll = React.useCallback(function (e) {
    var scrollLeft = e.target.scrollLeft;
    setScrollPosition(scrollLeft);
  }, []);
  var handleToLeftClick = function handleToLeftClick() {
    setScrollPosition(_.max(
    // 50 la marge pour voir l'ancien premier
    [scrollPosition - containerWidth + 50, 0]));
    if (onLeftScroll) {
      onLeftScroll();
    }
  };
  var handleToRightClick = function handleToRightClick() {
    setScrollPosition(_.min([
    // 50 la marge pour voir l'ancien dernier
    scrollPosition + containerWidth - 50, childrenWidth - containerWidth]));
    if (onRightScroll) {
      onRightScroll();
    }
  };
  var content = React.useMemo(function () {
    return /*#__PURE__*/_jsx(Grid.Column, Object.assign({
      style: {
        flex: 1,
        display: 'flex'
      }
    }, hideScrollbar && {
      className: 'jvsm-noscrollbar'
    }, {
      children: /*#__PURE__*/_jsx(Ref, {
        innerRef: handleRef,
        children: /*#__PURE__*/_jsx(Container, {
          id: uniqueId,
          fluid: true,
          style: {
            overflowX: 'auto',
            display: 'flex',
            flex: 1
          },
          onScroll: function onScroll(e) {
            if (e.target.id === uniqueId) {
              e.persist();
              handleManuallyScroll(e);
            }
          },
          children: /*#__PURE__*/_jsx(Ref, {
            innerRef: handleChildrenRef,
            children: _.isFunction(children) ? children(containerWidth, containerHeight) : /*#__PURE__*/React.cloneElement(children, {
              availableWidth: containerWidth,
              availableHeight: containerHeight
            })
          })
        })
      })
    }));
  }, [hideScrollbar, uniqueId, children, containerWidth, containerHeight, handleManuallyScroll]);
  if (!arrowButtons) {
    return /*#__PURE__*/_jsx(Container, Object.assign({
      fluid: true,
      style: {
        overflowX: 'auto'
      }
    }, rest, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(Container, Object.assign({
    fluid: true,
    style: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }
  }, rest, {
    children: /*#__PURE__*/_jsx(Grid, {
      style: {
        flex: 1,
        margin: 0
      },
      children: /*#__PURE__*/_jsxs(Grid.Row, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Grid.Column, {
          style: {
            width: 50,
            padding: 0,
            alignSelf: 'center'
          },
          children: /*#__PURE__*/_jsx(Icon, Object.assign({}, scrollPosition === 0 ? {
            disabled: true
          } : {
            link: true
          }, {
            name: "chevron left",
            size: "big",
            onClick: handleToLeftClick
          }))
        }), content, /*#__PURE__*/_jsx(Grid.Column, {
          style: {
            width: 50,
            padding: 0,
            alignSelf: 'center'
          },
          children: /*#__PURE__*/_jsx(Icon, Object.assign({}, childrenWidth < containerWidth || _.ceil(scrollPosition) === _.ceil(childrenWidth) - _.ceil(containerWidth) ? {
            disabled: true
          } : {
            link: true
          }, {
            name: "chevron right",
            size: "big",
            onClick: handleToRightClick
          }))
        })]
      })
    })
  }));
};
HorizontalScroller.handledProps = ["arrowButtons", "children", "hideScrollbar", "onLeftScroll", "onRightScroll"];
HorizontalScroller.propTypes = {
  /** Whether or not left and right arrow are displayed. */
  arrowButtons: PropTypes.bool,
  /** Whether or not horizontal scrollbar is displayed. */
  hideScrollbar: PropTypes.bool,
  /** Primary content. */
  children: PropTypes.node,
  /** Callback en left arrow click. */
  onLeftScroll: PropTypes.func,
  /** Callback en right arrow click. */
  onRightScroll: PropTypes.func
};
HorizontalScroller.defaultProps = {
  arrowButtons: true,
  onLeftScroll: null,
  onRightScroll: null
};
export default HorizontalScroller;